import { useAccordion } from "@material-tailwind/react";
import React, { useEffect, useMemo, useState } from "react";
import Config from "../../config/Config";
import { useAppSelector } from "../../core/feature/hooks";
import User from "../../core/models/user";
import TabsMobile from "../__template/TabsMobileComponent";
import users from "../../assets/images/icon_profile/user.svg";
import filter from "../../assets/images/icon_attendance/filter.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { getAttendanceDetail } from "../../core/service/api_attendance";
import { useDispatch } from "react-redux";
import { setLoading } from "../../core/feature/config/configSlice";
import moment from "moment";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
const ComponentAttendanceDetail = () => {
  const user: User = useAppSelector((state) => state.user.user);
  const [child, setchild] = useState<any>({});
  const [data, setData] = useState<any>([]);
  const [startDate, setStartDate] = useState(new Date());
  let location: any = useLocation();
  const [openDetailHistory, setOpenDetailHistory] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const funBg = useMemo(() => {
    var str = "white";
    return "bg-" + str;
  }, []);
  const env = Config.BaseUrlDev;

  const getProfileImage = (photo: string) => {
    if (photo == "") return users;
    return env + "main_base/image/get/" + photo + "/pas";
  };
  function onDismissDetailHistory() {
    setOpenDetailHistory(false);
  }

  const openSheetDetailHistory = async () => {
    setOpenDetailHistory(true);
  };
  const getData = async (date: string, callerId: string) => {
    dispatch(setLoading(true));
    getAttendanceDetail(date, callerId)
      .then((res: any) => {
        dispatch(setLoading(false));
        setData(res.data);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  function getStatus(status: String) {
    var temp = "";
    if (status == "DATANG TEPAT") {
      temp = t("ATTENDANCE-DETAIL.ontime");
    } else if (status == "DATANG TERLAMBAT") {
      temp = t("ATTENDANCE-DETAIL.late");
    } else if (status == "PULANG AWAL") {
      temp = t("ATTENDANCE-DETAIL.early");
    } else if (status == "PULANG TEPAT") {
      temp = t("ATTENDANCE-DETAIL.ontime");
    } else if (status == "PULANG LEMBUR" || status == "lembur") {
      temp = t("ATTENDANCE-DETAIL.overtime");
    } else {
      temp = "-";
    }
    return temp;
  }

  function getColor(status: String) {
    var temp = "";
    if (status == "DATANG TEPAT") {
      temp = "bg-teal-500";
    } else if (status == "DATANG TERLAMBAT") {
      temp = "bg-red";
    } else if (status == "PULANG AWAL") {
      temp = "bg-red";
    } else if (status == "PULANG TEPAT") {
      temp = "bg-teal-500";
    } else if (status == "PULANG LEMBUR" || status == "lembur") {
      temp = "bg-yellow";
    } else {
      temp = "bg-yellow";
    }
    return temp;
  }

  useEffect(() => {
    setchild(JSON.parse(location.state.data));
  }, []);

  useEffect(() => {
    if (child.callerId && location.state.date) {
      console.log(location.state.date);

      getData(moment(startDate).format("yyyy-MM-DD"), child.callerId);
    }
  }, [child]);
  return (
    <div className="min-h-screen h-full  bg-psp-primary">
      <div className={`px-8 pt-8 pb-3  sticky top-0 z-300 ${funBg}`}>
        <TabsMobile
          name={`${t("ATTENDANCE-DETAIL.title")}`}
          backUrl={"attendance"}
        ></TabsMobile>
      </div>
      <BottomSheet
        className="z-40"
        open={openDetailHistory}
        onDismiss={onDismissDetailHistory}
        defaultSnap={({ snapPoints, lastSnap }) =>
          lastSnap ?? Math.min(...snapPoints)
        }
        snapPoints={({ maxHeight }) => [
          maxHeight - maxHeight / 5,
          maxHeight * 0.8,
        ]}
        header={
          <h1 className="font-poppins flex items-left text-sm  font-bold text-black">
            {t("ATTENDANCE-DETAIL.filterDate")}
          </h1>
        }
        footer={
          <button
            onClick={onDismissDetailHistory}
            className="w-full bg-psp-btn-primary shadow-lg shadow-psp-primary text-white py-2.5 text-sm font-semibold rounded-lg"
          >
            {t("ATTENDANCE-DETAIL.close")}
          </button>
        }
      >
        <div className="px-4 py-2">
          <h1 className="font-poppins font-medium text-sm text-black my-2">
            {t("ATTENDANCE-DETAIL.filterDate")}:
          </h1>

          <DatePicker
            className="w-full h-10 text-sm px-2 border-2 border-solid border-psp-gray rounded-lg"
            selected={startDate}
            onChange={(date: Date) => (
              setStartDate(date),
              getData(moment(date).format("yyyy-MM-DD"), child.callerId),
              setOpenDetailHistory(false)
            )}
          />
        </div>
      </BottomSheet>

      <section className="px-4 py-6 flex flex-col top-to-bottom">
        <h1 className="font-montserrat text-sm font-medium ">
          {t("ATTENDANCE-DETAIL.information")}
        </h1>
        <div className="bg-white p-4 rounded-xl flex-row flex gap-3 items-center shadow-lg shadow-slate-100">
          <div className="flex flex-col grow">
            <h1 className="font-montserrat text-xs  font-medium text-psp-nav">
              {child.name}
            </h1>
            <span className="font-montserrat text-xs font-medium text-psp-gray">
              NIS: {child.callerId}
            </span>
          </div>
          <img
            src={getProfileImage(child.photoUrl)}
            className="w-14 h-14 rounded-full flex-0 object-cover"
          />
        </div>
        <div className="mt-3">
          <div className="flex flex-row justify-between w-full items-center mb-3">
            <h1 className="m-0 font-montserrat text-sm font-medium ">
              {t("ATTENDANCE-DETAIL.history")}
            </h1>
            <img
              onClick={() => {
                openSheetDetailHistory();
              }}
              src={filter}
              className="w-6 h-6"
            />
          </div>
          {data.length < 1 ? (
            <div className="flex justify-center">
              <span className="font-normal text-xs text-center">
                {t("OTHER.dataNotFound")}
              </span>
            </div>
          ) : (
            <div className="flex flex-col gap-2">
              {data.map((res: any) => (
                <div className="bg-white p-3 rounded-xl flex-row flex gap-3 items-center">
                  <img
                    src={res.photo_url_masuk}
                    className="w-14 h-14 rounded-lg object-cover"
                  />
                  <div className="flex flex-col w-full">
                    <div className="flex flex-row items-center w-full">
                      <h1 className="m-0 font-montserrat text-xs font-medium grow">
                        {res.shift_name}
                      </h1>
                      <span className="font-montserrat text-right font-medium text-psp-gray text-xs flex-0">
                        {moment(res.tanggal_absen).format("LL")}
                      </span>
                    </div>
                    <div className="flex justify-between mt-1">
                      <div className="flex flex-col">
                        <span className="font-montserrat text-xs font-medium">
                          {t("ATTENDANCE-DETAIL.in")}
                        </span>
                        <span className="font-montserrat text-psp-gray text-xs font-medium">
                          {res.jam_absen_masuk == ""
                            ? "-"
                            : res.jam_absen_masuk}
                        </span>
                        <span
                          hidden={res.sesi_ket_masuk == ""}
                          style={{ fontSize: 9 }}
                          className={`${getColor(
                            res.sesi_ket_masuk
                          )} px-2 rounded-md py-1  text-white  mt-1`}
                        >
                          {getStatus(res.sesi_ket_masuk)}
                        </span>
                      </div>
                      <div className="flex flex-col ">
                        <span className="font-montserrat text-xs font-medium text-right">
                          {t("ATTENDANCE-DETAIL.out")}
                        </span>
                        <span
                          className={
                            "font-montserrat text-psp-gray text-xs font-medium text-right"
                          }
                        >
                          {res.jam_absen_pulang == ""
                            ? "-"
                            : res.jam_absen_pulang}
                        </span>
                        <span
                          hidden={res.sesi_ket_pulang == ""}
                          style={{ fontSize: 9 }}
                          className={`${getColor(
                            res.sesi_ket_pulang
                          )} px-2 rounded-md py-1  text-white mt-1`}
                        >
                          {getStatus(res.sesi_ket_pulang)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        {/* {user.accounts[0].callerIdentities.map((res: any) => (
          <div className="bg-white p-3 rounded-xl flex-row flex gap-3 items-center">
            <img
              src={getProfileImage(res.photoUrl)}
              className="w-14 h-14 rounded-full"
            />
            <div className="flex flex-col ">
              <h1 className="font-montserrat text-xs  font-medium text-psp-nav">
                {res.name}
              </h1>
              <span
                style={{ fontSize: 9 }}
                className="font-montserrat  font-medium text-psp-gray"
              >
                NIS: {res.callerId}
              </span>
            </div>
          </div>
        ))} */}
      </section>
    </div>
  );
};

export default ComponentAttendanceDetail;
